import { Box, Loader } from '@wix/design-system'
import React, { FC, memo, ReactNode } from 'react'

type ContentWithLoadingProps = {
  isLoading?: boolean
  children?: ReactNode
}

export const ContentWithLoading: FC<ContentWithLoadingProps> = memo(({ isLoading, children }) => (
  <Box position="relative">
    {isLoading && (
      <Box position="absolute" top="0" left="0" bottom="0" right="0" verticalAlign="middle" align="center">
        <Loader size="tiny" />
      </Box>
    )}
    <span style={{ opacity: isLoading ? 0 : 1 }}>{children}</span>
  </Box>
))
